import { Button } from "@mui/material";
import { Box } from "@mui/system";

export const columns = [
  {
    name: "Gestión",
    selector: (row) => row.gestion,
    sortable: true,
    wrap: true,
    width: "100px",
  },
  {
    name: "Título",
    cell: (row) => <Box sx={{ py: "1rem" }}>{row.titulo}</Box>,
    sortable: true,
    sortFunction: (a, b) => {
      if (a.titulo < b.titulo) return -1;
      if (a.titulo > b.titulo) return 1;
      return 0;
    },
    wrap: true,
    width: "40%",
  },
  {
    name: "Código",
    selector: (row) => row.codigo,
    sortable: true,
    wrap: true,
    width: "175px",
  },
  {
    name: "Ver / Descargar",
    button: true,
    cell: (row) => (
      <>
        <a target="blank" href={row.link}>
          <Button
            sx={{ textDecoration: "inherit" }}
            size="small"
            variant="contained"
          >
            Ver / Descargar
          </Button>
        </a>
      </>
    ),
    width: "175px",
  },
  {
    name: "Tipo",
    selector: (row) => row.tipo,
    sortable: true,
    width: "175px",
  },
];
